import z from "zod";
import { PaginationParamsDTO, SortParamsDTO } from "./base";

export const GetCandidatesFilterDTO = z.object({
  keywords: z.string().optional(),
  pincodes: z.string().array().optional(),
  batchIds: z.coerce.number().array().optional(),
  examStatus: z.coerce.string().array().optional(),
  repaymentStatus: z.coerce.string().array().optional(),
  courseId: z.coerce.number().nullable().optional(),
  genders: z.enum(["male", "female"]).array().optional(),
  vleIds: z.coerce.bigint().array().optional(),
  stateIds: z.coerce.bigint().array().optional(),
  transactionNumbers: z.coerce.bigint().array().optional(),
  districtIds: z.coerce.bigint().array().optional(),
  highestQualifications: z
    .enum(["q_10", "q_12", "q_graduate", "q_post_graduate"])
    .array()
    .optional(),
  identityProofTypes: z
    .enum(["driving_license", "employers_card", "pan", "passport"])
    .array()
    .optional(),
  registrationStartDate: z.coerce.date().optional(),
  registrationEndDate: z.coerce.date().optional(),
  repaymentStartDate: z.coerce.date().optional(),
  repaymentEndDate: z.coerce.date().optional(),
});

export const GetCandidatesRequestInputDTO = z.object({
  filter: GetCandidatesFilterDTO,
  paginationParams: PaginationParamsDTO,
  sort: SortParamsDTO(
    z.enum([
      "createdAt",
      "name",
      "email",
      "mobileNumber",
      "gender",
      "highestQualification",
      "identityProofType",
      "identityProofNumber",
      "vleName",
      "vleId",
      "stateName",
      "districtName",
      "transactionNumber",
    ]),
  ),
});
